import React from 'react';
import './topbar.css';
import searchIcon from '../assets/search.svg';
import notificationIcon from '../assets/notification.svg';
import logoutIcon from '../assets/logout.svg';

const Topbar = ({ toggleSidebar }) => {
  return (
    <header className="topbar">
      <button className="topbar_burger" onClick={toggleSidebar}>
        ☰
      </button>
      <div className="topbar_actions">
        <label className="topbar_search" htmlFor="topbar-search">
          <img alt="" src={searchIcon} />
          <input id="topbar-search" placeholder="Search..." type="text" />
        </label>

        <button className="topbar_icon_button topbar_icon_button_notification" type="button">
          <img alt="" src={notificationIcon} />
        </button>

        <div className="topbar_user">
          <div className="topbar_user_text">
            <div className="topbar_user_name">Admin User</div>
            <div className="topbar_user_role">Administrator</div>
          </div>

          <div className="topbar_avatar">A</div>
        </div>

        <button className="topbar_icon_button" type="button">
          <img alt="" src={logoutIcon} />
        </button>
      </div>
    </header>
  );
};

export default Topbar;
